import React, { ReactElement } from 'react';
import Card from '../../../components/card/card.component';
import Button from '../../../components/button/button.component';
import ModalButtonBlock from '../../../components/modal-button-block/modal-button-block.component';
import ErrorBlock from '../../../components/error-block/error-block.component';
import ModalLayout from '../../../components/modal-layout/modal-layout.component';
import ModalFieldBlock from '../../../components/modal-field-block/modal-field-block.component';
import ModalDescription from '../../../components/modal-description/modal-description.component';
import Form from '../../../components/form/form.component';
import FormFieldText from '../../../components/form-field-text/form-field-text.component';

const ReportNewModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    errorMessage,
    onCreate,
    onCloseModal,
  } = props;

  return (
    <ModalLayout isOpen={isOpen} title="New Report Template" onCloseModal={onCloseModal}>
      <Form>
        <Card isContainer>
          <ModalDescription>
            Enter the name of new report template:
          </ModalDescription>
          <ModalFieldBlock>
            <FormFieldText isBordered name="reportData.name" />
          </ModalFieldBlock>
        </Card>
        <ModalButtonBlock>
          <Button onClick={onCloseModal}>
            Cancel
          </Button>
          <Button isActive onClick={onCreate}>
            Save
          </Button>
        </ModalButtonBlock>
        {
          !!errorMessage && (
            <ErrorBlock errorMessage={errorMessage} />
          )
        }
      </Form>
    </ModalLayout>
  );
});

export default ReportNewModal;
